import React, { useEffect, useState } from "react";
import { useParams } from "react-router-dom";
import SEO from "../common/SEO";
import Layout from "../common/Layout";
import { FaSistrix } from "react-icons/fa";

import SideCategories from "../components/blog/sidebar/SideCategories";
import SidebarPost from "../components/blog/sidebar/SidebarPost";
import SidebarTag from "../components/blog/sidebar/SidebarTag";
import BlogDetailsContent from "../components/blog/BlogDetailsContent";

const API_BASE_URL = process.env.REACT_APP_API_BASE_URL;

const BlogDetails = () => {
  const { id } = useParams();
  const [allContents, setAllContents] = useState([]);
  const [selectedContent, setSelectedContent] = useState(null);
  const [loading, setLoading] = useState(true);
  const [error, setError] = useState(null);

  useEffect(() => {
    const fetchAllContents = async () => {
      try {
        setLoading(true);
        setError(null);
        const token = localStorage.getItem("token");
        const res = await fetch(`${API_BASE_URL}/contents`, {
          headers: {
            Authorization: `Bearer ${token}`,
            Accept: "application/json",
          },
        });
        if (!res.ok) {
          throw new Error(`HTTP error! status: ${res.status}`);
        }
        const data = await res.json();
        setAllContents(data);

        // Find the selected content by id
        const selected = data.find((item) => String(item.id) === String(id));
        setSelectedContent(selected || null);
      } catch (err) {
        setError(err.message || "Failed to fetch data");
      } finally {
        setLoading(false);
      }
    };

    fetchAllContents();
  }, [id]);

  if (loading) return <div>Loading content...</div>;
  if (error) return <div>Error: {error}</div>;
  if (!selectedContent) return <div>Content not found.</div>;

  return (
    <>
      <SEO title={selectedContent.title || "Content Details || PWU"} />
      <Layout>
        <div className="rn-blog-details-area rn-section-gap">
          <div className="container">
            <div className="row row--30">
              {/* Main Blog Content */}
              <div className="col-lg-8 col-md-12">
                <div className="blog-content-wrapper">
                  <BlogDetailsContent data={selectedContent} />
                </div>
              </div>

              {/* Sidebar */}
              <div className="col-lg-4 col-md-12 mt_md--40 mt_sm--40">
                <aside className="rwt-sidebar">
                  <div className="rbt-single-widget widget_search mt--40">
                    <div className="inner">
                      <form className="blog-search" action="#">
                        <input type="text" placeholder="Search ..." />
                        <button className="search-button">
                          <FaSistrix />
                        </button>
                      </form>
                    </div>
                  </div>

                  <div className="rbt-single-widget widget_categories mt--40">
                    <h3 className="title">Categories</h3>
                    <div className="inner">
                      <SideCategories data={allContents} />
                    </div>
                  </div>

                  <div className="rbt-single-widget widget_recent_entries mt--40">
                    <h3 className="title">Recent Posts</h3>
                    <div className="inner">
                      <SidebarPost data={allContents} />
                    </div>
                  </div>

                  <div className="rbt-single-widget widget_tag_cloud mt--40">
                    <h3 className="title">Tags</h3>
                    <div className="inner mt--20">
                      <SidebarTag data={allContents} />
                    </div>
                  </div>
                </aside>
              </div>
            </div>
          </div>
        </div>
      </Layout>
    </>
  );
};

export default BlogDetails;
